import { useCacheSlice } from '../hooks'

export type Activity = {
  activity: string
  activity_description: string
  activity_group: string
}

export function useActivitiesCache() {
  const { data, isLoading } = useCacheSlice('activities')
  const activities = data as Activity[]
  return { activities, isLoading }
}
